import gateway from '@/_gateway.config.js'

export default function (appid, channelId, activityCode) {
  let url = encodeURIComponent(location.href)
  return `${gateway.ssoUrl}/h5logincenter?appId=${appid}&channel_id=${channelId}&activityCode=${activityCode}&redirect_uri=${url}`
}
